import {Component, OnInit, ViewChild} from "@angular/core";
import {ContentRowField} from "../../shared/content-row/content-row.component";
import {CardActivitiesService} from "../services/card-activities.service";
import {CardActivity, CardActivityType} from "../../dto/cardInfoModelBase";
import {ProductService} from "../services/product.service";
import {Product} from "../../dto/product";
import {toDateTimeString} from "../../providers/app-date-adapter";
import {MatTableGeneratorComponent} from "../../shared/mat-table-generator/mat-table-generator.component";
import {ReadonlyDataSource} from "../../table-datasouces/readonly.datasource";
import {IdentStatus} from "../../dto/ident-status";
import {DateTableFilter} from "../../table-datasouces/date-table-filter";
import {FormControl} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-card-activities',
  templateUrl: './card-activities.component.html',
  styleUrls: ['./card-activities.component.css']
})
export class CardActivitiesComponent implements OnInit {
  numberFromStr: string|null;
  numberToStr: string|null;

  constructor(
    private cardActivitiesService: CardActivitiesService,
    private productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;


  dataSource = new ReadonlyDataSource<CardActivity>(this.cardActivitiesService);
  public filters: DateTableFilter|null = null; // this is for the persistent sort field

  columns = [
    { columnDef: 'publicToken', header: 'Token', cell: row => `${row.card.token}`, sortable: true },
    { columnDef: 'product', header: 'Product', cell: row => this.productsById.get(row.card.productId)?.internalName, sortable: true },
    { columnDef: 'activityDate', header: 'Date', cell: row => `${toDateTimeString(row.activityDate) || ''}`, sortable: true },
    { columnDef: 'activityType', header: 'Type', cell: row => this.getActivityTypeString(row.activityType), sortable: false },
    { columnDef: 'mccCode', header: 'MCC', cell: row => row.mccCode, sortable: true },
    { columnDef: 'billAmt', header: 'Amount', cell: row => row.billAmount, sortable: true },
    { columnDef: 'txnDesc', header: 'Description', cell: row => row.description, sortable: true },


  ] as ContentRowField<CardActivity>[];

  private getActivityTypeString(activityType: CardActivityType) {
    if ( activityType == CardActivityType.Authorization )
      return "Auth";
    if ( activityType == CardActivityType.Presentment )
      return "Settle";
    if ( activityType == CardActivityType.CashWithdrawal )
      return "Cash";
    if ( activityType == CardActivityType.Reversal )
      return "Reversal";
    if ( activityType == CardActivityType.Load )
      return "Load";
    if ( activityType == CardActivityType.Other )
      return "Other";
  }

  productsById: Map<number, Product> = new Map();
  getRowClass: (row: any) => '';
  getViewLink = (item: CardActivity): string => item.id.toString();
  getEditLink = (item: CardActivity): string => item.id.toString() + '/edit';
  isLoading = false;

  loadData() {
    this.productService.getAll().subscribe(products => {
      products.data.forEach(value => this.productsById.set(value.id, value))
    });

  }

  ngOnInit(): void {

    this.filters = JSON.parse(sessionStorage.getItem('cardActivitiesTable')) ?? null;

    this.filters.dateFilterCols = ['activityDate'];

    this.table.filters = this.filters || new DateTableFilter();

    this.numberFromStr = this.table.filters.numberFrom?.toString();
    this.numberToStr = this.table.filters.numberTo?.toString();

    if ( this.filters.additionalField1 ) {
      let oh = this.filters.additionalField1?.split(',');
      this.mccGroupSelect.patchValue(oh);
    }



    this.table.applyFilter();

    this.loadData();

  }

  mccGroupSelect = new FormControl();
  productSelect = new FormControl();
  mccGroups = [
    { index: '0001-1499', name: 'Agricultural Services', },
    { index: '1500-2999', name: 'Contracted Services', },

    { index: '3000-3299', name: 'Airlines', },
    { index: '3300-3499', name: 'Card Rental', },
    { index: '3500-3999', name: 'Lodging', },

    { index: '4000-4799', name: 'Transportation Services', },
    { index: '4800-4999', name: 'Utility Services', },
    { index: '5000-5599', name: 'Retail Outlet Stores', },
    { index: '5600-5699', name: 'Clothing Stores', },
    { index: '5700-7299', name: 'Miscellaneous Stores', },
    { index: '7300-7999', name: 'Business Services', },
    { index: '8000-8999', name: 'Professional Services / Membership', },
    { index: '9000-9999', name: 'Government Services', },



    ];
  public dateFiltersList = [
    { name: 'activityDate', header: 'Transaction Date' },
  ];

  clearFilter() {
    this.mccGroupSelect.patchValue(null);
    this.productSelect.patchValue(null);
    this.table.clearFilter();
    sessionStorage.setItem('cardActivitiesTable', JSON.stringify({}));
  }

  onSearch(isInvalid = false) {

    if (!isInvalid) {
      console.log("test1111");
      console.log(this.mccGroupSelect.value);

      this.filters.additionalField1 = this.mccGroupSelect.value?.join(',');

      this.filters.numberFrom = parseFloat(this.numberFromStr);
      this.filters.numberTo = parseFloat(this.numberToStr);

      console.log(this.filters);

      // save filter
      sessionStorage.setItem('cardActivitiesTable', JSON.stringify(this.filters));
      if (!isInvalid) {
        this.table.filters = this.filters;
        this.table.applyFilter();
      }

    }
  }

}
